import { FormFieldValidatatorRule } from './types';

export const HAS_VALUE_VALIDATOR_RULE: FormFieldValidatatorRule = {
  test: (value: string) => value != null && value.length > 0,
  errorI18nKey: 'form/validation/empty_field',
  name: 'no-value',
};

export const ALWAYS_VALID_VALIDATOR_RULE: FormFieldValidatatorRule = {
  test: () => true,
  name: 'always-valid',
};

export default { HAS_VALUE_VALIDATOR_RULE, ALWAYS_VALID_VALIDATOR_RULE };
